import { Redirect } from 'expo-router';

// Web uses the app's onboarding overlay. Native apps have dedicated routes.
export default function OnboardingFallback() {
  return <Redirect href="/" />;
}
